module.exports = __webpack_public_path__ + "static/media/wavedeep.cbe37aa8.mp3";